export default __webpack_public_path__ + "assets/resizedsherbrooke-min.a9da241d.webp";